import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptors';

const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_MIKE_API_V2,
});

setupAuthInterceptors(apiV2);

export default apiV2;
